import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  items: [],
  paginator: null,
  isLoading: false,
  error: null,
  query: '',
  country: 'all',
  page: 1,
  onlyWithContracts: false,
  hasSearched: false,
  actionLoadingKey: null,
  lastActionAtByContractId: {},
}

const setQueryHandler = (state, { payload }) => {
  state.query = payload
  state.page = 1
}

const setCountryHandler = (state, { payload }) => {
  state.country = payload
  state.page = 1
}

const setOnlyWithContractsHandler = (state, { payload }) => {
  state.onlyWithContracts = Boolean(payload)
}

const setPageHandler = (state, { payload }) => {
  state.page = payload
}

const fetchListRequestHandler = state => {
  state.isLoading = true
  state.error = null
  state.hasSearched = true
}

const fetchListSuccessHandler = (state, { payload }) => {
  state.isLoading = false
  state.items = payload?.items || []
  state.paginator = payload?.paginator || null
  state.error = null
}

const fetchListFailureHandler = (state, { payload }) => {
  state.isLoading = false
  state.error = payload || 'Error'
}

const actionRequestHandler = (state, { payload }) => {
  state.actionLoadingKey = payload
}

const actionSuccessHandler = state => {
  state.actionLoadingKey = null
}

const actionFailureHandler = state => {
  state.actionLoadingKey = null
}

const patchItemByContractIdHandler = (state, { payload }) => {
   const contractId = payload?.contractId
      const patch = payload?.patch || {}
      if (!contractId) return

      const items = Array.isArray(state.items) ? state.items : []
      const idx = items.findIndex(it => String(it?.contractId) === String(contractId))
      if (idx === -1) return

        state.items[idx] = {
        ...items[idx],
        ...patch,
      }
  }

const markContractActionAtHandler = (state, { payload }) => {
  const contractId = payload?.contractId
  const action = payload?.action
  const at = payload?.at ?? Date.now()
  if (!contractId || !action) return
  if (!state.lastActionAtByContractId) state.lastActionAtByContractId = {}
  state.lastActionAtByContractId[`${action}:${contractId}`] = at
}

const slice = createSlice({
  name: 'contactsTools',
  initialState,
  reducers: {
    setQuery: setQueryHandler,
    setCountry: setCountryHandler,
    setOnlyWithContracts: setOnlyWithContractsHandler,
    setPage: setPageHandler,
    fetchListRequest: fetchListRequestHandler,
    fetchListSuccess: fetchListSuccessHandler,
    fetchListFailure: fetchListFailureHandler,
    actionRequest: actionRequestHandler,
    actionSuccess: actionSuccessHandler,
    actionFailure: actionFailureHandler,
    patchItemByContractId: patchItemByContractIdHandler,
    markContractActionAt: markContractActionAtHandler,
  },
})

export const {
  setQuery,
  setCountry,
  setPage,
  setOnlyWithContracts,
  fetchListRequest,
  fetchListSuccess,
  fetchListFailure,
  actionRequest,
  actionSuccess,
  actionFailure,
  patchItemByContractId,
  markContractActionAt,
} = slice.actions

export default slice.reducer
